import { IconChevronDown, IconChevronUp, IconFaceIdError } from '@tabler/icons-react'
import CourseCardSkeleton from '../../../components/CourseCard/CourseCardSkeleton/CourseCardSkeleton'
import useOwnCourses from '../../../hooks/useOwnCourses'
import OwnCoursesGridGroup from '../OwnCoursesGridGroup/OwnCoursesGridGroup'
import './OwnCoursesList.css'
import { useIsMount } from '../../../hooks/useIsMount'
import { Button, Select } from '@mantine/core'
import useOnboarding from '../../../hooks/useOnboarding'
import { TOUR_STEPS } from '../../../utils/tour'
import { useMemo, useState } from 'react'
import OnBoardingBtn from '../../../components/OnBoardingBtn/OnBoardingBtn'
import SpecialtiesBanner from '../SpecialtiesBanner/SpecialtiesBanner'

export default function OwnCoursesList() {
   const isMount = useIsMount()
   const {
      state,
      changeFilters,
      filters,
      groupedCourses
   } = useOwnCourses(isMount)

   const [selectedYear, setSelectedYear] = useState(null)

   const [runOnboarding, setRunOnboarding] = useState(false)
   const tour = useOnboarding({
      steps: TOUR_STEPS.ownCourses,
      disabled: (state.isLoading || state.error),
      page: 'ownCourses',
      runAgain: runOnboarding,
      lastBtnFunction: () => setRunOnboarding(false)
   })

   const yearOptions = useMemo(() => {
      return groupedCourses.map(group => ({
         value: String(group.year),
         label: group.year === 'Sin año' ? 'Sin fecha' : `${group.year}`
      }))
   }, [groupedCourses])

   const visibleCourses = useMemo(() => {
      if (!selectedYear) return groupedCourses
      return groupedCourses.filter(group => String(group.year) === selectedYear)
   }, [groupedCourses, selectedYear])

   return (
      <section className='OwnCoursesList-container'>
         {tour}
         <OnBoardingBtn onClick={() => setRunOnboarding(true)} />
         {state.error &&
            <div className='OwnCoursesList-error-container'>
               < IconFaceIdError size={150} color='var(--color-red)' />
               <p className='OwnCoursesList-error--text'>{state.error}</p>
            </div>
         }

              

         {state.isLoading && < CourseCardSkeleton />}

         {(!state.error && !state.isLoading && groupedCourses.length !== 0) &&

            <>
               <div className='OwnCoursesList-filters'>
                  <Select
                     placeholder="Todos los años"
                     data={yearOptions}
                     label='Buscar por año'
                     value={selectedYear}
                     onChange={setSelectedYear}
                     clearable
                     allowDeselect
                     style={{ width: 180 }}
                  />
                  <Button style={{alignSelf: 'flex-end'}} id='OwnCoursesList--sort-button' w={'max-content'} onClick={() => changeFilters(filters.order === 'asc' ? 'des' : 'asc')}>
                     {filters.order === 'asc' ? < IconChevronUp /> : < IconChevronDown />}
                     <span>Porcentaje de avance</span>
                  </Button>
               </div>

               {visibleCourses.map((group) => (
                  <div key={group.year} className='OwnCoursesList-yearGroup'>
                    {<h3 className='OwnCoursesList-yearGroup--title'>{group.year !== 'Sin año'  ? `AÑO ${group.year}` : "Sin fecha"} {}</h3>}
                     <OwnCoursesGridGroup cardsToMap={group.data} />
                  </div>
               ))}
            </>
         }

         {(!state.error && !state.isLoading && groupedCourses.length === 0) &&
            <p className='OwnCoursesList-noResults--text'>No hemos encontrado resultados</p>
         }
      </section>
   )
}
